module.exports = __webpack_public_path__ + "static/media/photo6.bd796ef8.jpg";